import React from 'react';
import { Grid } from '@mui/material';
import { CotizacionData, ItemOfertaData } from '../../types';
import { PricingFields } from './fields/PricingFields';
import { PaymentFields } from './fields/PaymentFields';
import { DeliveryFields } from './fields/DeliveryFields';

interface ItemFormFieldsProps {
  currentItem: ItemOfertaData;
  itemIndex: number;
  parentData: CotizacionData;
  localSelectedDate: string;
  setLocalSelectedDate: (date: string) => void;
  handleItemChange: (field: keyof ItemOfertaData, value: string | number) => void;
  shouldValidate?: boolean; // Si debe mostrar validaciones de campos requeridos
}

/**
 * Componente para los campos del formulario de item
 */
export const ItemFormFields: React.FC<ItemFormFieldsProps> = ({
  currentItem,
  itemIndex,
  parentData,
  localSelectedDate,
  setLocalSelectedDate,
  handleItemChange,
  shouldValidate = true,
}) => {
  return (
    <Grid container spacing={2}>
      <PricingFields
        currentItem={currentItem}
        itemIndex={itemIndex}
        handleItemChange={handleItemChange}
        shouldValidate={shouldValidate}
      />
      <PaymentFields
        currentItem={currentItem}
        itemIndex={itemIndex}
        handleItemChange={handleItemChange}
      />
      <DeliveryFields
        currentItem={currentItem}
        itemIndex={itemIndex}
        parentData={parentData}
        localSelectedDate={localSelectedDate}
        setLocalSelectedDate={setLocalSelectedDate}
        handleItemChange={handleItemChange}
        shouldValidate={shouldValidate}
      />
      {/* Hidden field for total calculation */}
      {/* Note: This logic was in PricingFields in my previous plan, but let's check where it fits best. 
          The original code had it at the end. PricingFields included it. */}
    </Grid>
  );
};
